module.exports = __webpack_public_path__ + "static/converge3-a963ae7f7849cbf9f26db8af40db446e.jpg";